module.exports = __webpack_public_path__ + "c8adbf237572ef7f47774ccb5d14cb57.svg";